import { render, staticRenderFns } from "./CommissionProductModal.vue?vue&type=template&id=58c23c3e&scoped=true&"
import script from "./CommissionProductModal.vue?vue&type=script&lang=js&"
export * from "./CommissionProductModal.vue?vue&type=script&lang=js&"
import style0 from "./CommissionProductModal.vue?vue&type=style&index=0&id=58c23c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c23c3e",
  null
  
)

component.options.__file = "CommissionProductModal.vue"
export default component.exports